/* eslint-disable no-magic-numbers */
import React, { useState, useRef } from 'react';
import { messengerInit, messengerGetItems, messengerSetItems, messengerClearItems } from '~/providers/messenger';
import { EMOTIONS } from "./data";
import "./style.less";

const INIT_SUGGEST_DATA = {
	showSuggest: false,
	useSuggest: false,
	lastPost: 0,
	suggestWord: "",
	suggestItems: null,
	suggestInd: -1,
};

export default function MessengerPage() {
	messengerInit();
	const [items, setItems] = useState(messengerGetItems);
	const [data, setData] = useState(INIT_SUGGEST_DATA);
	const [showEmoji, setShowEmoji] = useState(false);
	const textareaEl = useRef(null);

	function addItem() {
		const text = textareaEl.current.value.trim();

		if (!text) {
			return;
		}

		let content = text;

		const matches = text.match(/:[a-zA-Z0-9]+:/ug);

		if (matches) {
			for (let ind = 0, max = matches.length; ind < max; ind++) {
				const name = matches[ind].replace(/:/ug, "");

				content = content.replace(new RegExp(matches[ind], "gu"), `<img src="/emoji/${name}.png" alt="${name}" />`);
			}
		}

		const newItem = {
			id: Math.random().toString(16),
			content,
			date: new Date().toString(),
		};

		textareaEl.current.value = "";
		textareaEl.current.focus();

		const newItems = [newItem, ...items];

		setItems(newItems);
		messengerSetItems(newItems);
	}

	function openItem() {
		const suggestWord = data.suggestItems[data.suggestInd];
		const rest = suggestWord.substr(data.suggestWord.length, suggestWord.length);

		textareaEl.current.value = `${textareaEl.current.value}${rest}: `;
		setData(INIT_SUGGEST_DATA);
		textareaEl.current.focus();
	}

	function onChange() {
		const el = textareaEl.current;
		const valueLen = el.value.length;
		const newData = { ...data };

		if (newData.useSuggest) {
			// pridavame nebo mazeme
			if (el.selectionStart > newData.lastPos || el.selectionStart === newData.lastPos - 1) {
				if (el.selectionStart > newData.lastPos) {
					newData.suggestWord += el.value[el.selectionStart - 1];
				} else if (newData.suggestWord) {
					newData.suggestWord = newData.suggestWord.substr(0, newData.suggestWord.length - 1);
				} else {
					newData.useSuggest = false;
					newData.suggestWord = "";
					newData.lastPos = 0;
				}

				newData.lastPos = el.selectionStart;
			// rusime to
			} else {
				newData.useSuggest = false;
				newData.suggestWord = "";
				newData.lastPos = 0;
			}
		} else if (!newData.useSuggest && valueLen && el.value[el.selectionStart - 1] === ":") {
			if (valueLen === 1 || (valueLen > 1 && el.value[el.selectionStart - 2] === " ")) {
				newData.useSuggest = true;
				newData.suggestWord = "";
				newData.lastPos = el.selectionStart;
			}
		} else if (valueLen === 0) {
			newData.useSuggest = false;
			newData.suggestWord = "";
			newData.lastPos = 0;
		}

		newData.showSuggest = newData.suggestWord.length > 1;
		newData.suggestItems = newData.showSuggest ? EMOTIONS.filter(item => item.indexOf(newData.suggestWord) !== -1) : null;
		newData.suggestInd = newData.showSuggest ? 0 : -1;
		setData(newData);
	}

	function onKeyDown(event) {
		if (data.useSuggest) {
			switch (event.which) {
				// up
				case 38:
					event.preventDefault();
					setData({
						...data,
						suggestInd: Math.max(0, Math.min(data.suggestInd - 1, data.suggestItems.length - 1)),
					});
					break;
				// down
				case 40:
					event.preventDefault();
					setData({
						...data,
						suggestInd: Math.max(0, Math.min(data.suggestInd + 1, data.suggestItems.length - 1)),
					});
					break;
				// esc
				case 27:
					setData(INIT_SUGGEST_DATA);
					event.preventDefault();
					break;
				// enter
				case 13: {
					event.preventDefault();
					openItem();
				}
					break;
				default:
			}
		}
	}

	function selectItem(ind: number) {
		setData({
			...data,
			suggestInd: ind,
		});
	}

	function createSuggestItem(name, ind) {
		const className = ["suggest__item", ...ind === data.suggestInd ? ["active"] : []].join(" ");
		const imgSrc = `/emoji/${name}.png`;

		return <div key={name} className={className} onMouseEnter={() => selectItem(ind)} onClick={openItem}>
			<span className="image">
				<img src={imgSrc} alt={name} />
			</span>
			<span className="title">{name}</span>
		</div>;
	}

	function emojiClick() {
		setShowEmoji(!showEmoji);
	}

	function addEmoji(item) {
		textareaEl.current.value += `:${item}: `;
	}

	function clearItems() {
		setItems([]);
		messengerClearItems();
	}

	return <div className="messengerPage">
		<h1 className="messengerPage__title">Messenger</h1>
		<h2 className="messengerPage__emojis" onClick={emojiClick}>Seznam emoji</h2>
		{ showEmoji
			? <ul className="messengerPage__emojisList">
				{EMOTIONS.map(item => <li key={item} className="messengerPage__emojisList__item" onClick={() => addEmoji(item)}>
					<img src={`/emoji/${item}.png`} alt={item} className="messengerPage__emojisList__itemImg" />
					<span className="messengerPage__emojisList__itemTitle">{item}</span>
				</li>)}
			</ul>
			: null
		}
		<div className="messengerPage__addSection">
			<textarea ref={textareaEl} className="messengerPage__textarea" onChange={onChange} onKeyDown={onKeyDown}></textarea>
			{ data.showSuggest
				? <div className="suggest">
					{ data.suggestItems.map((name, ind) => createSuggestItem(name, ind))}
				</div>
				: null
			}
			<div className="messengerPage_addSection__buttons">
				<button type="button" onClick={clearItems} className="messengerPage__clearBtn">Smazat zprávy</button>
				<button type="button" onClick={addItem} className="messengerPage__addBtn">Přidat</button>
			</div>
		</div>
		<ul className="messengerPage__list">
			{ items.map(item => <li key={item.id} className="messengerPage__list__item">
				<div className="inner-content">
					<p dangerouslySetInnerHTML={{ __html: item.content }}></p>
					<div className="date">{new Intl.DateTimeFormat('cs-CZ', { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }).format(new Date(item.date))}</div>
				</div>
			</li>)}
		</ul>
	</div>;
}
